
import React, { Component } from 'react';
import TooltipWrapper from 'shared/components/TooltipWrapper';
import MuiMenuItem from 'material-ui/MenuItem';
import shallowEqual from 'fbjs/lib/shallowEqual';


export default class MenuItem extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    const {tooltip, tooltipClassName, tooltipStyle, anchorOrigin, targetOrigin, ...other} = this.props;
    return (
      <TooltipWrapper
        popoverType="grey"
        tooltip={tooltip}
        tooltipClassName={tooltipClassName}
        tooltipStyle={tooltipStyle}
        anchorOrigin={anchorOrigin}
        targetOrigin={targetOrigin}
      >
        <MuiMenuItem {...other}/>
      </TooltipWrapper>
    );
  }
}

MenuItem.defaultProps = {
  anchorOrigin: {horizontal: 'left', vertical: 'center'},
  targetOrigin: {horizontal: 'right', vertical: 'center'},
};

MenuItem.muiName = 'MenuItem';
